import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { PayrollItem } from './payroll-item.model';
import { CalcType } from '../../../lookups/CalcType';

export const loadPayrollItems = createAction(
    '[PayrollItem/API] Load PayrollItems',
    props<{ payrollItems: PayrollItem[] }>()
);

export const addPayrollItem = createAction(
    '[PayrollItem/API] Add PayrollItem',
    props<{ payrollItem: PayrollItem }>()
);

export const upsertPayrollItem = createAction(
    '[PayrollItem/API] Upsert PayrollItem',
    props<{ payrollItem: PayrollItem }>()
);

export const addPayrollItems = createAction(
    '[PayrollItem/API] Add PayrollItems',
    props<{ payrollItems: PayrollItem[] }>()
);

export const upsertPayrollItems = createAction(
    '[PayrollItem/API] Upsert PayrollItems',
    props<{ payrollItems: PayrollItem[] }>()
);

export const updatePayrollItem = createAction(
    '[PayrollItem/API] Update PayrollItem',
    props<{ payrollItem: Update<PayrollItem> }>()
);

export const updatePayrollItems = createAction(
    '[PayrollItem/API] Update PayrollItems',
    props<{ payrollItems: Update<PayrollItem>[] }>()
);

export const deletePayrollItem = createAction(
    '[PayrollItem/API] Delete PayrollItem',
    props<{ id: string }>()
);

export const deletePayrollItems = createAction(
    '[PayrollItem/API] Delete PayrollItems',
    props<{ ids: string[] }>()
);

export const clearPayrollItems = createAction(
    '[PayrollItem/API] Clear PayrollItems'
);

export const getPayrollItems = createAction(
    '[PayrollItem/API] Get PayrollItems',
    (activeOnly: boolean = true) => ({ activeOnly })
);

export const putPayrollItems = createAction(
    '[PayrollItem/API] Put PayrollItems',
    props<{ items: PayrollItem[] }>()
);

export const getLaborTypes = createAction('[PayrollItem/API] Get LaborTypes');
export const loadLaborTypes = createAction(
    '[PayrollItem/API] Load LaborTypes',
    props<{ items: CalcType[] }>()
);
